/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

/**
 * @description <p>Возможные значения:</p>\n<ul>\n<li><b>1 - Message</b>: Сообщение</li>\n<li><b>2 - Notification</b>: Уведомление</li>\n<li><b>3 - Radio</b>: Прямой эфир</li>\n</ul>\n
 */
export const pushTypeEnumSchema = z.union([z.literal(1), z.literal(2), z.literal(3)]).describe("<p>Возможные значения:</p>\n<ul>\n<li><b>1 - Message</b>: Сообщение</li>\n<li><b>2 - Notification</b>: Уведомление</li>\n<li><b>3 - Radio</b>: Прямой эфир</li>\n</ul>\n")